import logger from '@/utils/logger';
import {
  buildOptions,
  getEndPoints
} from '../../../utils/api-call';
import {
  makeCall
} from '../../../utils/request';
import {
  FETCH_LEGEND_PATH,
  FETCH_LEGEND_PATH_BY_PRACTICES,
  FETCH_EMBER_PATHS,
  SET_EMBER_PATHS,
  FETCH_EMBER_PRACTICES,
  FETCH_EMBER_PRACTICES_BY_ID,
  SET_EMBER_PRACTICES,
  SET_EMBER_CURRENT_PRACTICE,
  FETCH_EMBER_PRACTICES_BY_PATHS,
  FETCH_EMBER_HPA_TAGS,
  SET_EMBER_HPA_TAGS
} from './constants';

export const state = {
  paths: null,
  practices: null,
  currentPractice: null,
  hpaTags: null
};

export const actions = {
  [FETCH_LEGEND_PATH] ({ commit }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().embers.legendPaths,
        buildOptions('GET', options), commit)
        .then(response => {
          if (response.doubleClick) {
            return;
          }
          resolve(response.data.body);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_LEGEND_PATH_BY_PRACTICES] ({ commit }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().embers.legendPathByPractices,
        buildOptions('POST', options), commit)
        .then(response => {
          resolve(response.data);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_EMBER_PATHS] ({ commit }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().embers.paths,
        buildOptions('GET', options), commit)
        .then(response => {
          if (response.doubleClick) {
            return;
          }
          const result = response.data.body;
          result.forEach((item) => { item.title = item.name; });
          commit(SET_EMBER_PATHS, result);
          resolve(result);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_EMBER_PRACTICES_BY_PATHS] ({ commit }, options) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().embers.practicesByPathId.replace('{pathId}', options.pathId),
        buildOptions('GET', options), commit)
        .then(response => {
          if (response.doubleClick) {
            return;
          }
          const result = response.data;
          result.forEach((item) => { item.title = item.name; });
          commit(SET_EMBER_PRACTICES, result);
          resolve(result);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_EMBER_PRACTICES] ({ commit }) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().embers.practices,
        buildOptions(), commit)
        .then(response => {
          if (response.doubleClick) {
            return;
          }
          const result = response.data.body;
          result.forEach((item) => { item.title = item.name; });
          commit(SET_EMBER_PRACTICES, result);
          resolve(result);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_EMBER_PRACTICES_BY_ID] ({ commit }, options) {
    if (!options.practiceId) {
      return;
    }
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().embers.practicesById.replace(':id', options.practiceId),
        buildOptions(), commit)
        .then(response => {
          if (response.doubleClick) {
            return;
          }
          const result = response.data.body;
          commit(SET_EMBER_CURRENT_PRACTICE, result);
          resolve(result);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  },
  [FETCH_EMBER_HPA_TAGS] ({ commit }) {
    return new Promise((resolve, reject) => {
      makeCall(
        getEndPoints().embers.hpaTags,
        buildOptions(), commit)
        .then(response => {
          const result = response.data.body;
          if (result && result.length > 0) {
            result.forEach(r => {
              r.value = r.uuid;
              r.text = r.name;
            });
          }
          commit(SET_EMBER_HPA_TAGS, result);
          resolve(result);
        }, error => {
          logger.error('error=', error);
          reject(error);
        });
    });
  }
};

export const getters = {
  getEmberPaths: state => state.paths,
  getEmberPractices: state => state.practices,
  getEmberCurrentPractice: state => state.currentPractice,
  getEmberHpaTags: state => state.hpaTags
};

export const mutations = {
  [SET_EMBER_PATHS] (currentState, data) {
    currentState.paths = data;
  },
  [SET_EMBER_PRACTICES] (currentState, data) {
    currentState.practices = data;
  },
  [SET_EMBER_CURRENT_PRACTICE] (currentState, data) {
    currentState.currentPractice = data;
  },
  [SET_EMBER_HPA_TAGS] (currentState, data) {
    currentState.hpaTags = data;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
